import React from 'react';
import { Color, Size, Box } from '@americanexpress/aqx-components';

const BoxContainer = ({ styles, children, padding = {} }) => (
  <Box
    $border
    className={styles.content}
    theme={{
      rounded: Size.SM,
      borderColor: Color.Gray02,
      marginBottom: 20,
      ...padding
    }}
  >
    {children}
  </Box>
);

export default BoxContainer;
